// THIS FILE IS USED TO GENERATE CHUNKS PER PAGE
// SO THAT SPA'S CAN LOAD THE NECESSARY CHUNKS PER PAGE
/* eslint-disable no-nested-ternary */
import { generateAsyncRoute } from '@thd-olt-component-react/router';

const ssr = typeof window === 'undefined';

let serverPagesPromise = null;

const loadServerPages = async () => {
  const [
    { MobileNav },
    { CloseAccountPage },
    { ProfilePage },
    { AddManageUsersPage },
    { DashboardPage },
  ] = await Promise.all([
    import('./pages/MobileNav'),
    import('./pages/CloseAccountPage'),
    import('./pages/ProfilePage'),
    import('./pages/AddManageUsersPage'),
    import('./pages/DashboardPage'),
  ]);
  return {
    MobileNav,
    CloseAccountPage,
    ProfilePage,
    AddManageUsersPage,
    DashboardPage,
  };
};

export const getServerPages = async () => {
  if (!ssr) return {};
  if (!serverPagesPromise) {
    serverPagesPromise = loadServerPages().catch((error) => {
      serverPagesPromise = null;
      throw error;
    });
  }
  return serverPagesPromise;
};

export const getRoutes = (
  currentRouteName,
  currentRouteComponent,
  serverPages,
) => ({
  navigation: {
    name: 'mobileNav',
    componentName: 'MobileNav',
    chunk: () => import('./pages/MobileNav'),
    get component() {
      return ssr
        ? serverPages.MobileNav
        : currentRouteName === 'mobileNav'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.MobileNav,
              })),
            );
    },
    path: '/:context?/myaccount/profile/menu',
    channel: null,
  },
  closeAccount: {
    name: 'closeAccountPage',
    componentName: 'CloseAccountPage',
    chunk: () => import('./pages/CloseAccountPage'),
    get component() {
      return ssr
        ? serverPages.CloseAccountPage
        : currentRouteName === 'closeAccountPage'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.CloseAccountPage,
              })),
            );
    },
    path: '/:context?/myaccount/profile/closeAccount',
    channel: null,
  },
  home: {
    name: 'profilePage',
    componentName: 'ProfilePage',
    chunk: () => import('./pages/ProfilePage'),
    get component() {
      return ssr
        ? serverPages.ProfilePage
        : currentRouteName === 'profilePage'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.ProfilePage,
              })),
            );
    },
    path: '/:context?/myaccount/profile',
    channel: null,
  },
  addManageUsers: {
    name: 'addManageUsersPage',
    componentName: 'AddManageUsersPage',
    chunk: () => import('./pages/AddManageUsersPage'),
    get component() {
      return ssr
        ? serverPages.AddManageUsersPage
        : currentRouteName === 'addManageUsersPage'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.AddManageUsersPage,
              })),
            );
    },
    path: '/:context?/myaccount/addmanageusers',
    channel: null,
  },
  dashboard: {
    name: 'dashboardPage',
    componentName: 'DashboardPage',
    chunk: () => import('./pages/DashboardPage'),
    get component() {
      return ssr
        ? serverPages.DashboardPage
        : currentRouteName === 'dashboardPage'
          ? currentRouteComponent
          : generateAsyncRoute(() =>
              this.chunk().then((pageModule) => ({
                default: pageModule.DashboardPage,
              })),
            );
    },
    path: '/:context?/myaccount/dashboard',
    channel: null,
  },
});
